import { useContext, useState } from "react";

import { BottomBar, Menu, Seo } from "~components";
import { BaseContext } from "~context";

import { useRouter } from "next/router";
import { Layout } from "~components/common/Layout";
import { List, SubHeader } from "~components/events";
import {
  EventsServiceReturn,
  useEventsService,
} from "~features/events/hooks/useEventsService";

type QueryParams = {
  tourId: string;
};

const EventsPage = () => {
  const router = useRouter();
  const { tourId } = router?.query as QueryParams;

  const events = useEventsService({
    search: undefined,
    tourId,
    includeFeaturedEvents: true,
  });

  return <Events {...events}></Events>;
};

const Events = ({
  events,
  featuredEvents,
  isLoading,
  error,
}: EventsServiceReturn) => {
  const { organization } = useContext(BaseContext);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState<string>(undefined);

  const filteredEvents = search?.trim()
    ? events.filter((e) =>
        e.title.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
      )
    : events;

  const toggleSearch = () => setShowSearch(!showSearch);

  return (
    <>
      <Seo title="Events overview" description="Events overview page for" />
      <Menu>
        <SubHeader
          showSearch={showSearch}
          setSearch={setSearch}
          toggleSearch={toggleSearch}
          hasBackground={!!organization?.branding?.background}
        />
      </Menu>
      <Layout layoutType="main">
        <List
          isLoading={isLoading}
          error={error}
          setSearch={setSearch}
          events={filteredEvents}
          featuredEvents={featuredEvents}
        />
      </Layout>
      <BottomBar />
    </>
  );
};

export default EventsPage;
